{
  "buyToken": "ซื้อ{{token}}",
  "sellToken": "ขาย{{token}}",
  "viewOrder": "ดูคำสั่งซื้อ",
  "requestedAmount": "ยอดที่ขอ",
  "actualPaidAmount": "ยอดชำระจริง",
  "transactionQuantity": "จำนวนที่ทำรายการ",
  "completedListedQuantity": "จำนวนที่สำเร็จ/ที่ลงรายการ",
  "fastTrack": "ธุรกรรมด่วน",
  "status": "สถานะ: {{status}}",
  "noOrders": "ยังไม่มีคำสั่งซื้อ",
  "orderDetails": "รายละเอียดคำสั่งซื้อ",
  "matchedOrders": "คำสั่งซื้อที่จับคู่",
  "listing": "กำลังลงรายการ",
  "transactionCompleted": "ทำรายการเสร็จสิ้น",
  "cancelling": "กำลังยกเลิก",
  "transactionCancelled": "ยกเลิกรายการแล้ว",
  "transactions": "คำสั่งซื้อธุรกรรม",
  "cancelListing": "ยกเลิกการลงรายการ",
  "orderInformation": "ข้อมูลคำสั่งซื้อ",
  "systemOrderNumber": "หมายเลขคำสั่งซื้อระบบ",
  "sourceOrder": "คำสั่งซื้อต้นทาง",
  "createdAt": "เวลาสร้าง",
  "completedAt": "เวลาสำเร็จ",
  "price": "ราคา",
  "listedQuantity": "จำนวนที่ลงรายการ",
  "minimumTransaction": "จำนวนขั้นต่ำต่อรายการ",
  "completedQuantity": "จำนวนที่สำเร็จ",
  "processingQuantity": "จำนวนที่กำลังดำเนินการ",
  "remainingQuantity": "จำนวนคงเหลือ",
  "refundedQuantity": "จำนวนที่คืนแล้ว",
  "receivedAmount": "ได้รับแล้ว",
  "expectedTotal": "คาดว่าจะได้รับทั้งหมด",
  "paymentMethods": "วิธีรับเงิน",
  "seller": "ผู้ขาย",
  "buyer": "ผู้ซื้อ",
  "specialParty": "คู่ค้าพิเศษ",
  "paymentAmount": "ยอดชำระ",
  "paymentMethod": "วิธีชำระเงิน",
  "expectedReceived": "คาดว่าจะได้รับ",
  "revising": "(กำลังแก้ไข)",
  "sellerReceivingInformation": "ข้อมูลรับเงินของผู้ขาย",
  "buyerPaymentInformation": "ข้อมูลชำระเงินของผู้ซื้อ",
  "name": "ชื่อ",
  "bankName": "ธนาคาร",
  "bankBranch": "สาขาธนาคาร",
  "bankAccountNumber": "เลขบัญชีธนาคาร",
  "account": "บัญชี{{method}}",
  "receivingCode": "รหัสรับเงิน{{method}}",
  "modificationRequest": "คำขอแก้ไขข้อมูล",
  "originalQuantity": "จำนวนก่อนแก้ไข",
  "originalAmount": "ยอดก่อนแก้ไข",
  "updatedQuantity": "จำนวนหลังแก้ไข",
  "updatedAmount": "ยอดหลังแก้ไข",
  "sellerPaymentProof": "หลักฐานการชำระเงินของผู้ขาย",
  "imageFormatInvalid": "รูปแบบรูปภาพไม่รองรับ",
  "imageTooLarge": "ขนาดรูปภาพเกินขีดจำกัด 5 MB",
  "cancelOrder": "ยกเลิกคำสั่งซื้อ",
  "cancelOrderVideoInstruction": "หากต้องการยกเลิกคำสั่งซื้อนี้ โปรดบันทึกและอัปโหลดวิดีโอรายการเดินบัญชีออนไลน์ให้เห็นเวลาปัจจุบันอย่างชัดเจน",
  "cancelOrderVideoSteps": "เปิดร้านแอป ค้นหาและเปิดแอปธนาคาร จากนั้นไปที่ข้อมูลบัตรและรายการธุรกรรม",
  "back": "กลับ",
  "confirmCancel": "ยืนยันการยกเลิก",
  "paymentInProgress": "กำลังชำระเงิน",
  "buyerPaymentInProgress": "ผู้ซื้อกำลังชำระเงิน",
  "paymentTimeRemaining": "เวลาชำระเงินคงเหลือ",
  "buyerPaymentInstruction": "ชำระเงินตามข้อมูลรับเงินของผู้ขาย อัปโหลดหลักฐานแล้วกด “ฉันชำระเงินแล้ว”",
  "waitingForBuyerPayment": "กำลังรอผู้ซื้อชำระเงิน",
  "uploadPaymentProof": "อัปโหลดหลักฐานการชำระเงิน",
  "paymentProofUploadHint": "อัปโหลดรูปภาพ 1 ถึง 3 รูป แต่ละรูปไม่เกิน 5 MB รองรับ JPG, JPEG และ PNG",
  "paid": "ฉันชำระเงินแล้ว",
  "startAppeal": "ยื่นอุทธรณ์",
  "awaitingSellerRelease": "รอผู้ขายปล่อยเหรียญ",
  "awaitingRelease": "รอการปล่อยเหรียญ",
  "releaseTimeRemaining": "เวลาปล่อยเหรียญคงเหลือ",
  "releaseAfterConfirmation": "เหรียญจะถูกปล่อยหลังยืนยันการรับเงิน",
  "buyerPaidReleaseInstruction": "ผู้ซื้อชำระเงินแล้ว โปรดยืนยันแล้วกด “ปล่อยเหรียญ”",
  "buyerPaidConfirmation": "ผู้ซื้อชำระเงินแล้ว โปรดตรวจสอบว่าได้รับเงินโอนจากผู้ชำระด้านล่างแล้ว จากนั้นยืนยันการรับเงินและปล่อยเหรียญ",
  "appealAmountMismatch": "อุทธรณ์/จำนวนเงินไม่ตรง",
  "confirmReceiptAndRelease": "ยืนยันรับเงินและปล่อยเหรียญ",
  "sellerReleasedToken": "ผู้ขายปล่อยเหรียญแล้ว",
  "respondToOrderChange": "ตอบกลับการแก้ไขคำสั่งซื้อ",
  "agreeToOrderChange": "ยอมรับการแก้ไขคำสั่งซื้อนี้หรือไม่",
  "disagree": "ไม่ยอมรับ",
  "agree": "ยอมรับ",
  "revisingOrder": "กำลังแก้ไข",
  "sellerRequestedOrderChange": "ยอดที่ผู้ขายได้รับไม่ตรงตามที่คาดไว้ จึงขอแก้ไขคำสั่งซื้อ โปรดเลือกตอบกลับการแก้ไขคำสั่งซื้อ",
  "orderChangeSubmitted": "ส่งคำขอแก้ไขคำสั่งซื้อแล้ว โปรดรอผู้ซื้อตอบกลับ",
  "sellerCancelling": "ผู้ขายกำลังยกเลิก",
  "orderCancellationInProgress": "กำลังยกเลิกคำสั่งซื้อ โปรดรอสักครู่ เราจะแจ้งให้ทราบหลังการตรวจสอบ",
  "appealOrder": "อุทธรณ์คำสั่งซื้อ",
  "appealOrderDescription": "เมื่อยื่นอุทธรณ์ ฝ่ายบริการลูกค้าจะเข้ามาดูแลธุรกรรมนี้จนกว่าจะสิ้นสุด",
  "confirmAppeal": "ยืนยันการอุทธรณ์",
  "confirmCancelOrder": "ยืนยันว่าต้องการยกเลิกคำสั่งซื้อนี้หรือไม่",
  "unlistOrder": "ยกเลิกการลงรายการ",
  "lotteryFailed": "จับรางวัลไม่สำเร็จ โปรดลองอีกครั้งภายหลัง",
  "lotteryTicketLoadFailed": "ไม่สามารถโหลดบัตรจับรางวัลได้ โปรดลองอีกครั้งภายหลัง",
  "drawing": "กำลังจับรางวัล…",
  "draw": "แตะเพื่อจับรางวัล",
  "finishDrawing": "เสร็จสิ้น",
  "ticketUnavailable": "บัตรจับรางวัลนี้ถูกใช้ไปแล้วหรือใช้ไม่ได้",
  "congratulations": "ยินดีด้วย คุณได้รับ",
  "tokenRedEnvelope": "อั่งเปา {{token}}",
  "redEnvelopeImage": "รูปภาพอั่งเปา",
  "redEnvelopeDelivered": "ยอดอั่งเปาถูกเพิ่มในยอดคงเหลือกระเป๋าเงินของคุณแล้ว",
  "noPrize": "พลาดรางวัลใหญ่ไปนิดเดียว ลองอีกครั้ง!",
  "appealInProgress": "กำลังอุทธรณ์",
  "appealSupportInstruction": "โปรดเลือกติดต่อฝ่ายสนับสนุนที่มุมขวาบนเพื่อพูดคุยกับฝ่ายสนับสนุน",
  "paymentProof": "หลักฐานการชำระเงิน",
  "fastTrackDetails": "รายละเอียดธุรกรรมด่วน"
}
